<template>
  <v-container class="p-2">
    <OverlayPageVue :showOverlay="loader" />
    <v-card flat>
      <v-row no-gutters>
        <v-col cols="1" class="m-auto">
          <img
            src="../../../assets/master_logo.png"
            alt="QQPay"
            style="max-height: 60px; max-width: 120px"
          />
        </v-col>
        <v-col cols="5">
          <p class="font-weight-bold ma-0 pa-0">QQ Pay Sdn Bhd</p>
          <p class="ma-0 pa-0">
            Level 20, Menara 1 Sentrum, 201,
            <br />
            Jalan Tun Sambanthan, Brickfields, <br />50470 Kuala Lumpur,Wilayah
            Persekutuan Kuala Lumpur
          </p>
          <a href="https://qqpay.io/" target="_blank">www.qqpay.io</a>
        </v-col>
        <v-col cols="3">
          <p class="ma-0 pa-0">
            PIN NUMBER:<span class="font-weight-bold">
              {{ this.transactionDetails.txn_data.pin_umber }}</span
            >
          </p>
          <p class="ma-0 pa-0">
            Transaction ID:<span class="font-weight-bold">
              {{ this.transactionDetails.txn_data.txn_id }}</span
            >
          </p>
          <p>
            Transaction Date: {{ this.transactionDetails.txn_data.txn_date }}
          </p>
        </v-col>
        <v-col cols="2" class="mt-3">
          <div class="text-center">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  class="text-capitalize"
                  depressed
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  More Options
                  <v-icon class="ms-1" small>mdi-menu-down-outline</v-icon>
                </v-btn>
              </template>

              <v-card class="m-auto pa-2">
                <v-list class="d-flex">
                  <v-list-item link class="text-center">
                    <v-list-item-title>
                      <v-icon class="pt-2">mdi-close</v-icon>
                      <p class="caption">Cancel Txn</p>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item link class="text-center">
                    <v-list-item-title>
                      <v-icon class="pt-2">mdi-cancel</v-icon>
                      <p class="caption">Block Txn</p>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item link class="text-center">
                    <v-list-item-title>
                      <v-icon class="pt-2">mdi-swap-horizontal</v-icon>
                      <p class="caption">Post to Un-Paid</p>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-list class="d-flex pa-0">
                  <v-list-item link class="text-center">
                    <v-list-item-title>
                      <v-icon class="pt-2">mdi-information</v-icon>
                      <p class="caption">Settlement Details</p>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item link class="text-center">
                    <v-list-item-title>
                      <v-icon class="pt-2">mdi-file-pdf-box</v-icon>
                      <p class="caption">Export to PDF</p>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item link class="text-center">
                    <v-list-item-title>
                      <v-icon class="pt-2">mdi-reload</v-icon>
                      <p class="caption">API log</p>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>
        </v-col>
      </v-row>
      <v-divider class="pa-0 m-auto" style="width: 95%"></v-divider>
      <v-simple-table style="width: 95%" class="m-auto mb-4 pa-2">
        <tr>
          <!-- <td colspan="2">
            Transaction ID:<span class="font-weight-bold">45364534563</span>
          </td> -->
          <td colspan="4" class="primary-bg pa-1">
            Transaction Status:<span class="font-weight-bold">{{
              this.transactionDetails.txn_data.txn_status
            }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2">QQPay Remittance Sdn Bhd</td>
          <td>Payout Partner</td>
          <td class="font-weight-bold">: {{ "Remitx" }}</td>
        </tr>
        <tr>
          <td colspan="2">Head Office</td>
          <td>Transaction Type</td>
          <td class="font-weight-bold">
            : {{ this.transactionDetails.txn_data.payment_mode }}
          </td>
        </tr>
        <tr>
          <td colspan="2"><b>MALAYSIA</b></td>
          <td>Paid By</td>
          <td></td>
        </tr>
      </v-simple-table>
      <v-card width="95%" class="m-auto">
        <senderinfo
          @senderdataUpdated="getTxnDetailsbyID"
          :senderInfo="transactionDetails.sender_data"
        />
        <reciever-info
          @RecieverDataUpdated="getTxnDetailsbyID"
          :recieverInfo="transactionDetails.receiver_data"
        />
        <transaction-info :transactionInfo="transactionDetails.txn_data" />
      </v-card>

      <txn-comments :remarksInfo="transactionDetails.remarks_data" />
    </v-card>
  </v-container>
</template>

<script>
import Senderinfo from "./TransactionDetails/SenderDetails.vue";
import RecieverInfo from "./TransactionDetails/RecieverInfo.vue";
import TransactionInfo from "./TransactionDetails/TransactionInfo.vue";
import TxnComments from "./TransactionDetails/TxnComments.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "../../../utils/OverlayPage.vue";
import AgentService from "@/services/agentService/AgentService";
// import CommonService from "@/services/CommonService/commonService.js";
import axios from "axios";
export default {
  name: "Hold Details",
  data() {
    return {
      transactionDetails: {},
      release_items: [],
      counter: 200,
      charLimit: (v) => {
        if (v && v.length > 200) {
          return "Text must be 200 characters or less";
        } else if (!v) {
          return "Required";
        } else {
          return true;
        }
      },
      remarks: "",
      accept_txn: false,
      selectedReleaseItem: null,
      validations: {
        releaseRules: [(v) => !!v || "Required"],
        remarksRules: [(v) => !!v || "Required"],
      },
    };
  },
  mixins: [alerts],
  components: {
    TransactionInfo,
    RecieverInfo,
    Senderinfo,
    TxnComments,
    OverlayPageVue,
  },
  mounted() {
    console.log(this.$route.query.id);

    if (this.$route.query.id) {
      this.getTxnDetailsbyID();
    }
    // this.getReleaseRemarks();
  },
  methods: {
    async pushtxnbyId() {
      const pin_number = this.$route.query.payment_id;
      const validate = this.$refs.releaseForm.validate();
      if (validate) {
        this.loader = true;
        try {
          const responseData = await axios.get(
            `${process.env.VUE_APP_CRONE_SERVICE}/api/v1/txn/push-transaction-by-pin?pin_number=${pin_number}&remarks=${this.remarks}`,

            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem(
                  "access_token",
                )}`,
                accept: "application/json",
              },
            },
          );
          if (responseData?.data?.status_code === 200) {
            this.$router.push({
              path: "/TransPush",
              query: {
                istodaytnx: false,
              },
            });
            this.loader = false;
            this.showAlertSuccess(
              `Transaction Pushed : ${responseData.data.message}`,
            );
            this.getpushTransactions("false");
          } else {
            this.loader = false;
            this.showAlertError(
              `Transaction pushed : ${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`,
            );
          }
        } catch (e) {
          this.loader = false;
          console.log(e);
          this.showAlertError(`Transaction pushed : Something went wrong`);
        }
      }
    },

    async getTxnDetailsbyID() {
      try {
        const responseData = await AgentService.getHoldTxnDetails(
          this.$route.query.id,
        );
        if (responseData && responseData.data.status_code === 200) {
          console.log(responseData.data);
          this.transactionDetails = { ...responseData.data.data[0] };
          console.log("kill", this.transactionDetails);
        }
        // else if (responseData.data.status_code === 401) {
        //   this.getTxnDetailsbyID();
        // }
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
// table,
// th,
// td {
//   border-bottom: 1px solid rgb(195, 195, 195);
//   border-collapse: collapse;
//   padding: 5px;
// }
.primary-bg {
  background-color: rgb(230, 228, 228);
}
.v-list-item {
  justify-content: center;
  padding: 0px;
}
.min_width {
  min-width: 300px;
}
</style>
